document.addEventListener("teeinblue-event-after-cart-added", () => {
  Shopify.KT_addItemFromForm();
  cartApp.updateCart();
  cartApp.openCart();
});

document.addEventListener("teeinblue-event-component-injected", function () {
  const elementToMove = document.querySelector(".tee-product-price");
  const insertAfterElement = document.querySelector(".product-name");
  if (elementToMove && insertAfterElement) {
    insertAfterElement.after(elementToMove);
  }
  const wrapperDiv = document.createElement("div");
  wrapperDiv.className = "tee-floow-free-reinigungsset";

  
  const newDiv = document.createElement("div");
  newDiv.className = "floow-container";
  newDiv.innerHTML = "Inklusive gratis Reinigungsset! 🧼";

  wrapperDiv.appendChild(newDiv);

  const targetElement = document.getElementById("teeFormActions");

  targetElement.appendChild(wrapperDiv);
});


document.addEventListener('teeinblue-event-component-injected', function() {
	const elementToMove = document.querySelector('#custom-tax');
	const insertAfterElement = document.querySelector('.tee-product-price');
	if (elementToMove && insertAfterElement) {        
	 insertAfterElement.after(elementToMove)
	}
});


window.onload = function() {
    var checkPropertiesInterval = setInterval(function() {
        var strongProperties = document.querySelectorAll('.properties-floow-cart-drawer-vue span');
      
        strongProperties.forEach(function(strongProperty) {
            if (strongProperty.textContent.includes('customization_id') || strongProperty.textContent.includes('tib_design_link')) {
                strongProperty.parentElement.style.display = 'none';
            }
        });
    }, 500); 
};